class CollapsibleTiles extends HTMLElement {
  constructor() {
    super()

    this.carousel = this.querySelector('swiper-container')
  }

  connectedCallback() {
    this.addCarouselParameters()
  }

  addCarouselParameters() {
    Object.assign(this.carousel, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      slidesOffsetAfter: 16,
      slidesOffsetBefore: 16,
      breakpoints: {
        992: {
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
        }
      },
      on: {
        init: (swiper) => {
          swiper.el.style.overflow = 'visible';
        }
      }
    });
    
    this.carousel.initialize();
  }
}

if (!customElements.get('collapsible-tiles'))
  customElements.define('collapsible-tiles', CollapsibleTiles)